export class PartyRepresentation {
  attorney?: string;
  role?: string;
  type?: string;
}
